import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { Upload } from '@element-plus/icons-vue'
import UploadFileModal from './UploadFileModal.vue'
import { isJA } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['sendType', 'isChoice'],
  emits: ['submit'],
  setup(__props, { emit: emits }) {

const props = __props


const show = ref(false)
const open = () => {
  show.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isJA)())
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          icon: _unref(Upload),
          class: "mr_10",
          onClick: open
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('导入发货数量')), 1)
          ]),
          _: 1
        }, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createVNode(UploadFileModal, {
      visible: show.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      sendType: __props.sendType,
      isChoice: __props.isChoice,
      onSubmit: _cache[1] || (_cache[1] = e => emits('submit', e))
    }, null, 8, ["visible", "sendType", "isChoice"])
  ], 64))
}
}

})